import { DialogContent, Typography, Box, Stack } from '@mui/material'

import type React from 'react'
import { useTranslation } from 'react-i18next'
import { match } from 'ts-pattern'

import type { MenuVendor } from '../../domain/menu-vendor'

type Props = {
  vendor: Pick<MenuVendor, 'companyName' | 'sourcing'>
}

export const SourcingTab: React.FC<Props> = ({ vendor }) => {
  const hasSourcingData = Boolean(vendor.sourcing)
  const { t } = useTranslation()

  return (
    <DialogContent>
      <Stack direction="column" spacing={2} alignItems="flex-start">
        {match(hasSourcingData)
          .with(true, () => (
            <>
              <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                {t('cc:allInformationProvidedBy')} {vendor.companyName}
              </Typography>

              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
                  {t('cc:ingredientSources')}
                </Typography>
                <Box sx={{ py: 0.5 }}>
                  <Typography variant="caption" sx={{ lineHeight: '24px' }}>
                    {vendor.sourcing}
                  </Typography>
                </Box>
              </Box>
            </>
          ))
          .with(false, () => (
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
                {t('marketplace:noSourcingInfo')}
              </Typography>
              <Typography variant="caption" sx={{ lineHeight: '24px' }}>
                {t('marketplace:waitingOnInfoFrom')} {vendor.companyName}
              </Typography>
            </Box>
          ))
          .exhaustive()}
      </Stack>
    </DialogContent>
  )
}
